import React, {ReactElement} from 'react';
import ModalWrapper, {ModalButton} from "../ModalWrapper/ModalWrapper";
import {toDisplayDateTimeFormat} from "../../../utils/dateUtils";

const GENERIC_COMMUNICATION_FAILURE_HEADER = 'Communication Failure';
const GENERIC_COMMUNICATION_FAILURE_MESSAGE = 'There has been a communication failure. The data you see may not be accurate, please refresh your browser. If this error continues, please contact the support team.';

export interface GenericErrorModalData {
    isOpen: boolean;
    header: string;
    message: string | ReactElement;
    operationId: string;
    errorDetail?: string,
    profileId?: string;
    time?: Date;
}

export const genericEmptyErrorModalData: GenericErrorModalData = {
    isOpen: false,
    header: '',
    message: '',
    operationId: ''
}

export const getGenericCommunicationErrorModalData = (error: {headers?: {get?: (name: string) => string | undefined}}): GenericErrorModalData => ({
    isOpen: true,
    header: GENERIC_COMMUNICATION_FAILURE_HEADER,
    message: GENERIC_COMMUNICATION_FAILURE_MESSAGE,
    operationId: error?.headers?.get?.('trace-id') ?? ''
});

interface GenericErrorModalProps {
    buttonText?: string;
    onClickButton?: () => void;
    onRequestClose?: () => void;
    errorModalData: GenericErrorModalData;
    buttonProps?: Partial<ModalButton>;
    alertIcon?: string,
    alertIconType?: string,
    showAlertIcon?: boolean
}

const GenericErrorModal: React.FC<GenericErrorModalProps> = ({
                                                                 buttonText = 'Close',
                                                                 onClickButton,
                                                                 onRequestClose,
                                                                 errorModalData,
                                                                 buttonProps,
                                                                 alertIcon='warning',
                                                                 alertIconType='error',
                                                                 showAlertIcon = true
                                                             }) => {

    const renderDetail = (label: string, value: string)=> {
        return <div>{`${label}: ${value}`}</div>;
    }

    return (
        <ModalWrapper
            id="Generic Error Modal"
            headerText={errorModalData.header}
            isOpen={errorModalData.isOpen}
            showCloseButton={onRequestClose !== undefined}
            alertIconType={alertIconType}
            alertIcon={showAlertIcon ? alertIcon : undefined}
            onRequestClose={onRequestClose}
            buttons={[
                {
                    text: buttonText,
                    onClick: onClickButton,
                    ...buttonProps
                },
            ]}
        >
            <div>{errorModalData.message}</div>
            <div className="secondary-text">
                <br/>
                {
                    errorModalData.errorDetail && <div>{errorModalData.errorDetail}</div>
                }
                {
                    errorModalData.profileId && renderDetail('Profile', errorModalData.profileId)
                }
                {
                    errorModalData.time && renderDetail('Time', toDisplayDateTimeFormat(errorModalData.time?.toISOString()))
                }
                <div>{`Operation ID: ${errorModalData.operationId}`}</div>
            </div>
        </ModalWrapper>
    )
}

export default GenericErrorModal;